(() => {
  // Mobile: skip the scale-on-scroll animation entirely (eliminates ~25-31ms forced reflow on mobile).
  if (window.matchMedia('(max-width: 989px)').matches) return;

  const IMG_SELECTOR = ".big-logo-group .group-block-content .image-block img";
  const CONTAINER_SELECTOR = ".big-logo-group .group-block-content .image-block";
  const FLAG = "scaleScrollInit";

  const MIN_SCALE = 0.3;       // start scale
  const DESIRED_MAX = 1.8;     // “want it big”, but will clamp to container width

  // @ts-ignore
  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  const MAX_CONTAINER_WIDTH = 3000;

  // @ts-ignore
  function computeMaxScale(img, container) {
    // widths as currently rendered (scale should be ~1 here)
    const cw = Math.min(container.getBoundingClientRect().width || 1, MAX_CONTAINER_WIDTH);
    const iw = img.getBoundingClientRect().width || 1;

    // If iw already equals cw, maxScaleAllowed ~= 1
    const maxScaleAllowed = cw / iw;

    // Don’t ever go below 1 (otherwise it would shrink-only)
    return Math.max(1, Math.min(DESIRED_MAX, maxScaleAllowed));
  }

  function init(container = document) {
    const imgs = Array.from(container.querySelectorAll(IMG_SELECTOR));
    if (!imgs.length) return;

    // Add to registry
    // @ts-ignore
    window.__scaleOnScroll = window.__scaleOnScroll || { items: [], bound: false };

    imgs.forEach((img) => {
      // @ts-ignore
      if (img.dataset[FLAG] === "1") return;
      // @ts-ignore
      img.dataset[FLAG] = "1";

      const box = img.closest(CONTAINER_SELECTOR) || img.parentElement;
      if (!box) return;

      // @ts-ignore
      img.style.transformOrigin = "50% 50%";
      // @ts-ignore
      img.style.willChange = "transform";

      // @ts-ignore
      window.__scaleOnScroll.items.push({ img, box, maxScale: 1 });
    });

    function recalc() {
      // @ts-ignore
      window.__scaleOnScroll.items = window.__scaleOnScroll.items.filter(x => x.img.isConnected);

      // @ts-ignore
      window.__scaleOnScroll.items.forEach((item) => {
        // Temporarily clear transform so we measure at scale(1)
        const prev = item.img.style.transform;
        item.img.style.setProperty("transform", "scale(1)", "important");
        item.maxScale = computeMaxScale(item.img, item.box);
        item.img.style.transform = prev || "scale(1)";
      });
    }

    let ticking = false;

    function update() {
      ticking = false;

      const vh = window.innerHeight || document.documentElement.clientHeight;

      // @ts-ignore
      window.__scaleOnScroll.items.forEach(({ img, box, maxScale }) => {
        if (!img.isConnected) return;

        const r = box.getBoundingClientRect();

        // progress 0..1 as container moves from bottom of viewport toward top
        const start = vh;       // enters viewport
        const end = vh * 0.15;   // reaches full scale much higher up (was 0.8 – slower expansion)
        const raw = (start - r.top) / (start - end);
        const linear = clamp(raw, 0, 1);

        // ease-out curve: fast start that decelerates → feels smooth
        const p = 1 - Math.pow(1 - linear, 3.5);

        const scale = MIN_SCALE + (maxScale - MIN_SCALE) * p;
        img.style.transform = `scale(${scale})`;
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    // Bind once globally
    // @ts-ignore
    if (!window.__scaleOnScroll.bound) {
      // @ts-ignore
      window.__scaleOnScroll.bound = true;
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", () => {
        recalc();
        onScroll();
      });
    }

    // If images load after JS, recalc then
    imgs.forEach((img) => {
      // @ts-ignore
      if (!img.complete) img.addEventListener("load", () => { recalc(); onScroll(); }, { once: true });
    });

    recalc();
    onScroll();
  }

  // @ts-ignore
  function cleanup(container) {
    const imgs = Array.from(container.querySelectorAll(IMG_SELECTOR));
    imgs.forEach((img) => {
      delete img.dataset[FLAG];
      img.style.willChange = "";
    });

    // @ts-ignore
    if (window.__scaleOnScroll?.items) {
      // @ts-ignore
      window.__scaleOnScroll.items = window.__scaleOnScroll.items.filter(x => x.img.isConnected);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }
  // @ts-ignore
  document.addEventListener("shopify:section:load", (e) => init(e.target));
  document.addEventListener("shopify:section:unload", (e) => cleanup(e.target));
})();